import { format, getTime, formatDistanceToNow } from 'date-fns';

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy';

  return date ? format(new Date(date), fm) : '';
}

export function fDateTime(date, newFormat) {
  const fm = newFormat || 'dd MMM yyyy p';

  return date
    ? format(
        new Date(
          new Date(date).getTime() - new Date(date).getTimezoneOffset() * 60000,
        ),
        fm,
      )
    : '';
}

export function fTimestamp(date) {
  return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
  return date
    ? formatDistanceToNow(new Date(date), {
        addSuffix: true,
      })
    : '';
}

export function fTimeAgo(dateString) {
  const currentDate = new Date();
  const targetDate = new Date(`${dateString}`);
  const localTargetDate = new Date(
    targetDate.getTime() - targetDate.getTimezoneOffset() * 60000,
  );

  const timeDifference = currentDate - localTargetDate;
  const seconds = Math.floor(timeDifference / 1000);
  const minutes = Math.floor(seconds / 60);
  const hours = Math.floor(minutes / 60);
  const days = Math.floor(hours / 24);

  if (seconds < 60) {
    return 'Just now';
  }
  if (minutes < 60) {
    return `${minutes} ${minutes === 1 ? 'min' : 'mins'} ago`;
  }
  if (hours < 24) {
    return `${hours} ${hours === 1 ? 'hour' : 'hours'} ago`;
  }
  return `${days} ${days === 1 ? 'day' : 'days'} ago`;
}

export default function fDateDiff(inputDateString) {
  const inputDate = new Date(inputDateString);

  const timeZoneOffsetInMinutes = new Date().getTimezoneOffset();
  inputDate.setMinutes(inputDate.getMinutes() - timeZoneOffsetInMinutes);

  const day = inputDate.getDate();
  const options = { month: 'short' };
  const month = inputDate.toLocaleDateString('en-US', options);

  let dayWithSuffix;
  if (day % 10 === 1 && day !== 11) {
    dayWithSuffix = `${day}st`;
  } else if (day % 10 === 2 && day !== 12) {
    dayWithSuffix = `${day}nd`;
  } else if (day % 10 === 3 && day !== 13) {
    dayWithSuffix = `${day}rd`;
  } else {
    dayWithSuffix = `${day}th`;
  }

  const formattedDate = `${dayWithSuffix} ${month}`;

  return formattedDate;
}

export function fDateDifference(inputDateString) {
  const inputDate = new Date(inputDateString);
  const currentDate = new Date();
  const differenceInMilliseconds = currentDate - inputDate;
  const differenceInDays = Math.floor(
    differenceInMilliseconds / (1000 * 60 * 60 * 24),
  );

  if (differenceInDays === 0) {
    return 'Today';
  }
  if (differenceInDays === 1) {
    return 'Yesterday';
  }
  return `${differenceInDays} days ago`;
}
